import { render, staticRenderFns } from "./RoomsList.vue?vue&type=template&id=6b31f60a"
import script from "./RoomsList.vue?vue&type=script&lang=js"
export * from "./RoomsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports